import { call, put, takeLatest } from "redux-saga/effects";

// Ecommerce Redux States
import {
  GET_TOYS,
  GET_TOYS_GROUPED,
  ADD_NEW_TOY,
  DELETE_TOY,
  UPDATE_TOY,
  UPDATE_TOY_AVAILABILITY,
} from "./actionTypes";

import { GET_CATEGORIES, } from "../categories/actionTypes";

import {
  getToysFail,
  getToysSuccess,
  getToysGroupedFail,
  getToysGroupedSuccess,
  getShopsSuccess,
  addToyFail,
  addToySuccess,
  updateToySuccess,
  updateToyFail,
  deleteToySuccess,
  deleteToyFail,
  updateToyAvailability,
  updateToyAvailabilitySuccess,
  updateToyAvailabilityFail,
  setLoading,
} from "./actions";

import {
  getCategoriesFail,
  getCategoriesSuccess,
} from "../categories/actions";

//Include Both Helper File with needed methods
import {
  getToys,
  getGroupedToys,
  addNewToy,
  updateToy,
  deleteToy,
  updateToysAvailability,
} from "helpers/toys_helper";
import { getCategories } from "helpers/category_helper";
// toast
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { setSystemError, setSystemLoading } from "store/actions";

function* fetchProducts() {
  try {
    const response = yield call(getProducts);
    yield put(getProductsSuccess(response));
  } catch (error) {
    yield put(getProductsFail(error));
  }
}

function* fetchProductDetail({ productId }) {
  try {
    const response = yield call(getProductDetail, productId);
    yield put(getProductDetailSuccess(response));
  } catch (error) {
    yield put(getProductDetailFail(error));
  }
}

function* fetchToys({ payload: { page, limit, query, status, category, type, cityId, showOnWebsite = "all", featured = "all" } }) {
  try {
    yield put(setSystemLoading(true));
    const response = yield call(getToys, page, limit, query, status, category, type, cityId, showOnWebsite, featured);
    yield put(getToysSuccess(response));
    yield put(setSystemError(false));
    yield put(setSystemLoading(false));
  } catch (error) {
    yield put(getToysFail(error));
    let errorMessage = !error?.response ? "No internet connection. Please check your network settings and try again." : error?.response?.data?.error || "Something went wrong";
    yield put(setSystemError(errorMessage));
  }
}

function* fetchToysGrouped({ payload: { page, limit, query, status, category, cityId, showOnWebsite = "all", featured = "all" } }) {
  try {
    yield put(setSystemLoading(true));
    const response = yield call(getGroupedToys, page, limit, query, status, category, cityId, showOnWebsite, featured);

    // Flatten the group structure for the Admin Table
    // The backend returns { groupId, toy, units, variantCount }
    // We map this to { ...toy, groupId, variants: units, variantCount }
    const formattedToys = response.toys.map(group => ({
      ...group.toy,
      groupId: group.groupId,
      variants: group.units,
      variantCount: group.variantCount
    }));

    yield put(getToysGroupedSuccess({ toys: formattedToys, totalToys: response.totalToys }));
    yield put(setSystemError(false));
    yield put(setSystemLoading(false));
  } catch (error) {
    console.log(error)
    yield put(getToysGroupedFail(error));
    let errorMessage = !error?.response ? "No internet connection. Please check your network settings and try again." : error?.response?.data?.error || "Something went wrong";
    yield put(setSystemError(errorMessage));
  }
}



function* onUpdateToy({ payload: toy }) {
  try {
    yield put(setLoading(true));
    const response = yield call(updateToy, toy);
    yield put(updateToySuccess(response));
    toast.success("Toy Update Successfully.");
  } catch (error) {
    yield put(updateToyFail(error));
    let msg = error?.response?.data?.error || "Toy Update Failed"
    toast.error(msg);
  }
}

function* onDeleteToy({ payload: toy }) {
  try {
    const response = yield call(deleteToy, toy);
    yield put(deleteToySuccess(toy));
    toast.success("Toy Delete Successfully");
  } catch (error) {
    yield put(deleteToyFail(error));
    let msg = error?.response?.data?.error || "Toy Delete Failed"
    toast.error(msg);
  }
}

function* onAddNewToy({ payload: toy }) {
  try {
    yield put(setLoading(true));
    const response = yield call(addNewToy, toy);
    yield put(addToySuccess(response));
    toast.success("Toy Added Successfully");
  } catch (error) {
    yield put(addToyFail(error));
    let msg = error?.response?.data?.error || "Toy Added Failed"
    toast.error(msg);
  }
}

function* getProductComents() {
  try {
    // todo - add product Id to the payload and api
    const response = yield call(getProductComentsApi);
    yield put(getProductCommentsSuccess(response));
  } catch (error) {
    yield put(getProductCommentsFail(error));
  }
}

function* onLikeComment({ payload: { commentId, productId } }) {
  try {
    // todo - add product Id to the payload and api
    const response = yield call(onLikeCommentApi, commentId, productId);
    yield put(onLikeCommentSuccess(response));
  } catch (error) {
    yield put(onLikeCommentFail(error));
  }
}

function* onLikeReply({ payload: { commentId, productId, replyId } }) {
  try {
    // todo - add product Id to the payload and api
    const response = yield call(onLikeReplyApi, commentId, productId, replyId);
    yield put(onLikeReplySuccess(response));
  } catch (error) {
    yield put(onLikeReplyFail(error));
  }
}

function* onAddReply({ payload: { commentId, productId, replyText } }) {
  try {
    const response = yield call(onAddReplyApi, commentId, productId, replyText);
    yield put(onAddReplySuccess(response));
  } catch (error) {
    yield put(onAddReplyFail(error));
  }
}

function* onAddComment({ payload: { productId, commentText } }) {
  try {
    const response = yield call(onAddCommentApi, productId, commentText);
    yield put(onAddCommentSuccess(response));
  } catch (error) {
    yield put(onAddCommentFail(error));
  }
}

function* onUpdateToyAvailability({ payload: { toyId, isAvailable } }) {
  try {
    const response = yield call(updateToysAvailability, toyId, isAvailable);

    // Dispatch success action
    yield put(updateToyAvailabilitySuccess(response));
    // Dispatch action to update isAvailable in Redux state
    yield put(updateToyAvailability(toyId, isAvailable));
    toast.success("Toy Availability Updated Successfully");
  } catch (error) {
    yield put(updateToyAvailabilityFail(error));
    toast.error("Toy Availability Update Failed");
  }
}

function* fetchCategories() {
  try {
    const response = yield call(getCategories);
    yield put(getCategoriesSuccess(response));
  } catch (error) {
    yield put(getCategoriesFail(error));
  }
}

function* toySaga() {
  yield takeLatest(GET_TOYS, fetchToys);
  yield takeLatest(GET_TOYS_GROUPED, fetchToysGrouped);
  yield takeLatest(ADD_NEW_TOY, onAddNewToy);
  yield takeLatest(UPDATE_TOY, onUpdateToy);
  yield takeLatest(DELETE_TOY, onDeleteToy);
  yield takeLatest(UPDATE_TOY_AVAILABILITY, onUpdateToyAvailability);
  yield takeLatest(GET_CATEGORIES, fetchCategories);
}

export default toySaga;
